var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoggerInfoDetails',{attrs:{"logger_type":"rain"}})
}
var staticRenderFns = []

export { render, staticRenderFns }